import { Props } from './types';
import { FuelTypography } from '@frete.com/fuel-react';
import { Grid } from '~components';
import { FieldRow } from '../../styled';

function CompanyDetails({ companyName, establishmentDate }: Props) {
  return (
    <Grid container direction="column" spacing={8}>
      <Grid>
        <FuelTypography size="body-lg" weight="bold">
          Dados da empresa
        </FuelTypography>
      </Grid>
      <Grid>
        <FieldRow container spacing={14}>
          <Grid xs={6}>
            <FuelTypography
              size="caption"
              color="neutral-default"
              weight="bold"
            >
              Razão social
            </FuelTypography>
            <FuelTypography size="body-sm" weight="bold">
              {companyName}
            </FuelTypography>
          </Grid>
          <Grid xs={6}>
            <FuelTypography
              size="caption"
              color="neutral-default"
              weight="bold"
            >
              Data de constituição
            </FuelTypography>
            <FuelTypography size="body-sm" weight="bold">
              {establishmentDate}
            </FuelTypography>
          </Grid>
        </FieldRow>
      </Grid>
    </Grid>
  );
}

export default CompanyDetails;
